import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';
import { ClientService } from '../../@core/data/clients/client.service';

import { NbToastrService } from '@nebular/theme';
import { ContractsError, ContractsLoaded, ContractsRequested } from './contracts.action';
import { IContractsState } from './contracts.state';
import { LoggedUserLoaded } from '../users/users.actions';


@Injectable()
export class ContractsEffects {
  constructor(
    private actions$: Actions,
    private clientService: ClientService
  ) {}

  requestContracts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContractsRequested),
      mergeMap((props) =>
        this.clientService.getContractsRedux(props.userId).pipe(
          map((response: {status:boolean, data:IContractsState['contracts']}) => {
            if (response.status){
              return ContractsLoaded({ contracts: response.data });
            }
            return ContractsLoaded({ contracts: [] });
          }),
          catchError((error: any) => of(ContractsError()))
        )
      )
    )
  );

  requestClietsAfterUserLogged$ = createEffect(() => 
    this.actions$.pipe(
      ofType(LoggedUserLoaded),
      map((props)=> ContractsRequested({userId: props.loggedUser.user_id}))
    )
  );

}
